import { Typography } from "@mui/material";
import { Handle, Position } from "@xyflow/react";

import type { QueryRuleNode, RuleNodeProps } from "../types/nodes";
import BaseNode from "./BaseNode";

type QueryBuilderNodeProps = RuleNodeProps<QueryRuleNode>;

const QueryBuilderNode = (props: QueryBuilderNodeProps) => {
	const { data } = props;

	return (
		<BaseNode {...props}>
			<Typography variant="body2" color="text.secondary">
        Table: {data.databaseTableName}
			</Typography>

			{data.conditions?.length ? (
				<ul style={{ marginLeft: 16 }}>
					{data.conditions.map((c, idx) => (
						<li key={idx}>
							{c.databaseTableFieldName} {c.operator} {String(c.value)}
						</li>
					))}
				</ul>
			) : (
				<Typography variant="body2" color="text.disabled">
          No conditions set
				</Typography>
			)}
			<Handle type="target" position={Position.Top} id="in" />
		</BaseNode>
	);
};

export default QueryBuilderNode;
